const sortable = true;
export const items = [
  {
    id: "workOrder",
    label: "WO #",
    sortable,
  },
  {
    id: "customer",
    label: "Customer",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "quantity",
    label: "Qty",
  },
  {
    id: "hours",
    label: "Hours",
  },
  {
    id: "startDate",
    label: "Start Date",
    sortable,
  },
  {
    id: "dueDate",
    label: "End Date",
    sortable,
  },
];
export const keys = [
  {
    value: "woNumber",
    variant: "blueBold",
    navigate: true,
    route: "works",
    id: "woNumber",
  },
  {
    value: "customer.name",
    variant: "blueBold",
    navigate: true,
    route: "customers",
    id: "customer.id",
  },
  {
    value: "partName",
    variant: "blueBold",
    navigate: true,
    route: "parts",
    id: "partId",
  },
  {
    value: "quantity",
  },
  {
    value: "hours",
    defaultValue: 0,
  },
  {
    value: "startDate",
    isDate: true,
  },
  {
    value: "endDate",
    isDate: true,
  },
];
